import React from "react";

const ArrowTopRightIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.44078 4.80005H11.2008M11.2008 4.80005V10.56M11.2008 4.80005L4.80078 11.2"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowTopRightIcon;
